import {bootstrapApplication} from '@angular/platform-browser';
import {appConfig} from './app/app.config';
import {App} from './app/app';
import {reloadOnChunkLoadError} from '@/app/core/utils/chunk-load-error.util';

window.addEventListener('unhandledrejection', (event) => {
  reloadOnChunkLoadError(event.reason);
});

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
